/**
 *
 */
(function ($, Drupal) {
  function loading() {
    setTimeout(() => {
      $("#block-loading").addClass("fade");
    }, 1000);
  }
  function parallaxMobile() {
    let fieldItem = document.querySelectorAll(
      ".field--name-field-page-content  > .field__item"
    );
    /* if (document.querySelector('.bottle-mobile') == null) {
      bottleMobile.classList.remove('.bottle-mobile');
    } */
    for (let index = 0; index < fieldItem.length; index++) {
      const element = fieldItem[index];
      if (index == 0) {
        setInterval(() => {
          element.classList.add("bottle-mobile");
        }, 1500);
      }
      if (index == 1) {
        element.classList.add("bottle-mobile-fin");
      }
      //start
      window.addEventListener("scroll", function (e) {
        let item_parallax_1 = document.querySelector(
          ".bottle-mobile-fin"
        );
        let bottleMobile = document.querySelector(".bottle-mobile");
        //item_parallax_1
        if (
          window.scrollY >=
          item_parallax_1.offsetTop -
            (item_parallax_1.offsetTop * 42) / 100
        ) {
          bottleMobile.classList.add("fade-bottle");
          item_parallax_1.classList.add("active");
        } else {
          bottleMobile.classList.remove("fade-bottle");
          item_parallax_1.classList.remove("active");
        }
      });
    }
  }
  function parallax() {
    let fieldItem = document.querySelectorAll(
      ".field--name-field-page-content  > .field__item"
    );
    setInterval(() => {
      let item_parallax_1 = document.querySelector(
        ".item-parallax-1"
      );
      item_parallax_1.classList.add("active");
      item_parallax_1.classList.add("bottle");
    }, 1500);

    for (let index = 0; index < fieldItem.length; index++) {
      const element = fieldItem[index];
      element.classList.add(`item-parallax-${index + 1}`);
    }
    //start
    window.addEventListener("scroll", function (e) {
      let item_parallax_1 = document.querySelector(
        ".item-parallax-1"
      );
      let item_parallax_2 = document.querySelector(
        ".item-parallax-2"
      );
      let item_parallax_3 = document.querySelector(
        ".item-parallax-3"
      );

      //item_parallax_1
      if (
        window.scrollY >=
        item_parallax_1.offsetTop -
          (item_parallax_2.offsetTop * 90) / 100
      ) {
        item_parallax_1.classList.add("active");
        item_parallax_1.classList.add("bottle");
      } else {
        item_parallax_1.classList.remove("active");
      }
      //item_parallax_2
      if (
        window.scrollY >=
        item_parallax_2.offsetTop -
          (item_parallax_2.offsetTop * 50) / 100
      ) {
        item_parallax_2.classList.add("active");
        item_parallax_1.classList.remove("active");
        item_parallax_1.classList.add("bottle-right");
      } else {
        item_parallax_2.classList.remove("active");
      }
      //item_parallax_3
      if (
        window.scrollY >=
        item_parallax_3.offsetTop -
          (item_parallax_3.offsetTop * 30) / 100
      ) {
        item_parallax_3.classList.add("active");
        item_parallax_1.classList.add("bottle-left");
        item_parallax_1.classList.remove("bottle-right");
      } else {
        item_parallax_1.classList.remove("bottle-left");
        item_parallax_3.classList.remove("active");
      }
    });
  }
  function sliderProduct() {
    $(
      ".paragraph--type--steps-products > .field--name-field-steps"
    ).slick({
      slidesToShow: 3,
      infinite: false,
      dots: true,
      arrows: true,
      swipe: true,
      touchMove: true,
      slidesToShow: 3,
      speed: 500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
          },
        },
        {
          breakpoint: 980,
          settings: {
            autoplay: false,
            slidesToShow: 3,
            infinite: true,
            vertical: true,
            dots: false,
            adaptiveHeight: true,
          },
        },
      ],
    });
  }
  //Slider animate home
  function sliderAnimateHome() {
    $(
      ".paragraph--type--slider-animate > .aos-container > .field--name-field-slider-animate-item > .field__items"
    ).slick({
      infinite: true,
      dots: true,
      // arrows: true,
      swipe: true,
      autoplay: true,
      autoplaySpeed: 4000,
      touchMove: true,
      slidesToShow: 1,
      speed: 1400,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
          },
        },
        {
          breakpoint: 980,
          settings: {
            autoplay: false,
            slidesToShow: 1,
            infinite: true,
            // vertical: true,
            dots: false,
            adaptiveHeight: true,
          },
        },
      ],
    });
  }
  setTimeout(function(){
    console.log("review submit");
    jQuery(".webform-submission-suscription-form button[type='submit']").on("click",function(){ console.log("hola w")
      jQuery(".js-form-type-checkbox.form-item-terms-conditions input").on('click',function(){if(!jQuery(this).hasClass("valid")){jQuery(".js-form-type-checkbox").addClass("fail") }else{jQuery(".js-form-type-checkbox").removeClass("fail")}})
    })

  },1000)

  //Slider bottle aguila
  function sliderZoom() {
    $(
      ".paragraph--type--slider-zoom > .field--name-field-slider-zoom-item > .field__items"
    ).slick({
      infinite: true,
      dots: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      touchMove: true,
      speed: 1400,
      focusOnSelect: true,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            infinite: false,
            slidesToShow: 3,
            focusOnSelect: false,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            infinite: false,
            slidesToShow: 3,
            focusOnSelect: false,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            focusOnSelect: true,
          },
        },
      ],
    });
    if ($(".field--name-field-slider-zoom-item").length > 0) {
      jQuery(
        ".field--name-field-slider-zoom-item .field__items .slick-track .slick-slide"
      ).on("mouseover", function (e) {
        e.preventDefault();
        console.log("hover")
        jQuery(this).addClass("slick-active");
        jQuery(this).addClass("slick-current");
        jQuery(this).siblings().removeClass("slick-active");
        jQuery(this).siblings().removeClass("slick-current");
      });

    }
  }

  function sliderCard() {
    $(
      ".paragraph--type--slider-card > .field--name-field-slider-card-item"
    ).slick({
      infinite: true,
      dots: false,
      // arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      touchMove: true,
      speed: 500,
      arrows: false,
      focusOnSelect: true,
      // autoplay: true,
      responsive: [
        // {
        //   breakpoint: 1024,
        //   settings: {
        //     infinite: true,
        //     slidesToShow: 3,
        //   },
        // },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 1,
            focusOnSelect: true,
          },
        },
      ],
    });
  }
  if ($(".field--name-field-slider-card-item").length > 0) {
    jQuery(".field--name-field-slider-card-item .field__item").click(
      function () {
        jQuery(this).addClass("slick-active");
        jQuery(this).addClass("slick-current");
        jQuery(this).siblings().removeClass("slick-active");
        jQuery(this).siblings().removeClass("slick-current");
      }
    );
  }
  /**
   *
   * @type {{attach: Drupal.behaviors.co_aguila_new.attach}}
   */
  Drupal.behaviors.co_aguila_new = {
    attach: function (context) {
      window.onload = loading;
      if ($(".paragraph--type--slider-animate").length > 0) {
        sliderAnimateHome();
      }
      if ($(".paragraph--type--slider-zoom ").length > 0) {
        sliderZoom();
      }
      if ($(".field--name-field-animate-cover").length > 0) {
        jQuery(window).scroll(function () {
          var tapitRotate = jQuery(window).scrollTop() / 2.2;
          jQuery(".cover-rotate-scroll img").css({
            transform: "rotate(" + tapitRotate + "deg)",
          });
        });
      }
      if ($(".field--name-field-slider-card-item").length > 0) {
        sliderCard();
      }
      if ($("body").hasClass("page-node-type-principal-page")) {
        //sliderProduct();
        var viewportWidth =
          window.innerWidth || document.documentElement.clientWidth;
        window.addEventListener("load", function (event) {
          if (viewportWidth > 992) {
            AOS.init();
          } else {
            parallaxMobile();
          }
        });
      }
      if ($("body").hasClass("agegate-visible")) {
        $('button.age_gate_yes').on('click', function () {
          location.reload();
        })
      }
    },
  };

  Drupal.behaviors.co_caption = {
    attach: function (context) {
      if (
        $(
          ".paragraph--type--video-title-description-cta, .paragraph--type--video-back-title-desc"
        ).length > 0 &&
        $(".modal-video").length == 0
      ) {
        $("#main").append(
          '<div aria-hidden="true" aria-labelledby="myLargeModalLabel" class="modal fade modal-video" role="dialog" tabindex="-1">' +
            '<div class="modal-dialog modal-lg">' +
            '<div class="modal-content">' +
            '<button aria-label="Close" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">Close</span></button>' +
            '<div class="content-src">&nbsp;</div>' +
            "</div>" +
            "</div>" +
            "</div>"
        );

        ModalActive(
          ".paragraph--type--video-title-description-cta, .paragraph--type--video-back-title-desc",
          "#main"
        );
      }
      function ModalActive(parentContent, parentModal) {
        let container = jQuery(parentContent);
        jQuery(parentModal)
          .find(".modal")
          .on("click", function () {
            jQuery(parentModal)
              .find(".content-src iframe")[0]
              .contentWindow.postMessage(
                '{"event":"command","func":"' +
                  "pauseVideo" +
                  '","args":""}',
                "*"
              );
          });
        container.find(".yt-img").on("click", function (e) {
          let iframe = document.createElement("iframe");
          let dataSrc =
            "https://www.youtube.com/embed/" +
            jQuery(this).find("picture[data-src]").attr("data-src") +
            "?enablejsapi=1&version=3&playerapiid=ytplayer&rel=0&showinfo=0&autoplay=1";
          let parent = jQuery(parentModal);
          if (
            parent.find(".content-src iframe").length > 0 &&
            parent.find(".content-src iframe").attr("src") == dataSrc
          ) {
            parent
              .find(".content-src iframe")[0]
              .contentWindow.postMessage(
                '{"event":"command","func":"' +
                  "playVideo" +
                  '","args":""}',
                "*"
              );
          } else if (
            parent.find(".content-src iframe").length > 0 &&
            parent.find(".content-src iframe").attr("src") != dataSrc
          ) {
            parent.find(".content-src iframe").attr("src", dataSrc);
          } else {
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute(
              "allow",
              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            );
            // Important: add the autoplay GET parameter, otherwise the user would need to click over the YouTube video again to play it
            iframe.setAttribute("src", dataSrc);
            iframe.classList.add("video-custom");
            parent.find(".content-src").html(iframe);
          }
        });
      }
    },
  };

  //jQuery('.field--name-field-principal-content > .field__items')
})(jQuery, Drupal);
